export interface TolgeeExtensionCredentials {
  apiKey: string;
  apiUrl: string;
}

interface ResolveTolgeeRuntimeOptions {
  enabled: boolean;
  apiUrl?: string;
  apiKey?: string;
  isDev: boolean;
  editorDefaultEnabled?: boolean;
  locationSearch?: string;
  extensionCredentials?: TolgeeExtensionCredentials;
}

export function getTolgeeDevelopmentOverride(locationSearch = ''): boolean | undefined {
  const value = new URLSearchParams(locationSearch).get('tolgeeDevelopment');

  if (value === null) {
    return undefined;
  }

  if (value === '' || value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return undefined;
}

export function resolveTolgeeRuntime(options: ResolveTolgeeRuntimeOptions) {
  const runtimeEnabled = options.enabled && !!options.apiUrl;
  const browserApiEnabled = runtimeEnabled && !!options.apiKey;
  const devToolsEnabled = options.isDev && browserApiEnabled;
  const editorOverride = getTolgeeDevelopmentOverride(options.locationSearch);
  const editorModeRequested =
    runtimeEnabled && (editorOverride ?? !!options.editorDefaultEnabled);

  const instanceApiKey = options.extensionCredentials?.apiKey ?? options.apiKey;
  const instanceApiUrl = options.extensionCredentials?.apiUrl ?? options.apiUrl;
  const editorModeEnabled = editorModeRequested && !!instanceApiKey && !!instanceApiUrl;
  const instanceEnabled = devToolsEnabled || editorModeEnabled;

  return {
    runtimeEnabled,
    browserApiEnabled,
    devToolsEnabled,
    editorOverride,
    editorModeRequested,
    editorModeEnabled,
    instanceEnabled,
    instanceApiKey,
    instanceApiUrl,
    baseUrl: options.apiUrl?.replace(/\/+$/, ''),
  };
}
